import { render, staticRenderFns } from "./ProductSpecificationsTab.vue?vue&type=template&id=69aeb560&scoped=true&"
import script from "./ProductSpecificationsTab.vue?vue&type=script&lang=js&"
export * from "./ProductSpecificationsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69aeb560",
  null
  
)

export default component.exports